const KEY_AUTH = 'auth';
const KEY_ME = 'me';
const KEY_SKIP_LOGIN = 'skip_login';
const KEY_CPC_ID = 'cpc_id';
const KEY_USER_MOBILE = 'user_mobile';
const KEY_HAS_BEEN_LOGIN = 'has_been_login';
const KEY_LINE_BANK_IS_BINDED = 'line_bank_is_binded';
const KEY_IKNOW99_IS_BINDED = 'iknow99_is_binded';
const KEY_HAS_CHECKED_SERVICE_INSTRUCTION = 'has_checked_service_instruction';
const KEY_SCAN_PAY_RECEIPT_CODE_HIDDEN_STATE = 'scan_pay_receipt_code_hidden_state';
const KEY_SCAN_PAY_VIEWED_BOARD_LIST = 'scan_pay_viewed_board_list';

export const getScanPayViewedBoardList = () => {
  return JSON.parse(localStorage.getItem(KEY_SCAN_PAY_VIEWED_BOARD_LIST));
};

export const setScanPayViewedBoardList = id => {
  let list = getScanPayViewedBoardList() || [];
  list.push(id);
  return localStorage.setItem(KEY_SCAN_PAY_VIEWED_BOARD_LIST, JSON.stringify(list));
};

export const getScanPayReceiptCodeHiddenState = () => {
  return JSON.parse(localStorage.getItem(KEY_SCAN_PAY_RECEIPT_CODE_HIDDEN_STATE));
};

export const saveScanPayReceiptCodeHiddenState = bool => {
  return localStorage.setItem(KEY_SCAN_PAY_RECEIPT_CODE_HIDDEN_STATE, bool);
};

export const getHasCheckedServiceInstruction = () => {
  return localStorage.getItem(KEY_HAS_CHECKED_SERVICE_INSTRUCTION) || false;
};

export const saveHasCheckedServiceInstruction = () => {
  return localStorage.setItem(KEY_HAS_CHECKED_SERVICE_INSTRUCTION, true);
};

export const getHasBeenLogin = () => {
  return localStorage.getItem(KEY_HAS_BEEN_LOGIN) || false;
};

export const saveHasBeenLogin = () => {
  return localStorage.setItem(KEY_HAS_BEEN_LOGIN, true);
};

export const getLineBankIsBinded = () => {
  return localStorage.getItem(KEY_LINE_BANK_IS_BINDED) || false;
};

export const saveLineBankIsBinded = () => {
  return localStorage.setItem(KEY_LINE_BANK_IS_BINDED, true);
};

export const deleteLineBankIsBinded = () => {
  return localStorage.removeItem(KEY_LINE_BANK_IS_BINDED);
};

export const getIknow99IsBinded = () => {
  return localStorage.getItem(KEY_IKNOW99_IS_BINDED) || false;
};

export const saveIknow99IsBinded = () => {
  return localStorage.setItem(KEY_IKNOW99_IS_BINDED, true);
};

export const skipLogin = () => {
  return localStorage.setItem(KEY_SKIP_LOGIN, true.toString());
};

export const getSkipLogin = () => {
  return localStorage.getItem(KEY_SKIP_LOGIN) || false;
};

export const getAuth = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY_AUTH));
  } catch (e) {
    return null;
  }
};

export const saveAuth = obj => {
  return localStorage.setItem(KEY_AUTH, JSON.stringify(obj));
};

export const deleteAuth = () => {
  return localStorage.removeItem(KEY_AUTH);
};

// 將 me 存在 memory 即可
let me = null;

export const clearDeprecatedGetMe = () => {
  localStorage.setItem(KEY_ME, null);
};

export const getMe = () => {
  return me;
};

export const saveMe = obj => {
  me = obj;
};

export const saveCpcId = id => {
  sessionStorage.setItem(KEY_CPC_ID, id);
};

export const getCpcId = () => {
  return sessionStorage.getItem(KEY_CPC_ID);
};

export const saveUserMobile = mobile => {
  sessionStorage.setItem(KEY_USER_MOBILE, mobile);
};

export const getUserMobile = () => {
  return sessionStorage.getItem(KEY_USER_MOBILE);
};

export const clearAuth = () => {
  localStorage.removeItem(KEY_AUTH, null);
};

export const clearSkipLogin = () => {
  localStorage.removeItem(KEY_SKIP_LOGIN);
};
